export default {
  type: "object",
  properties: {
    size_charts: {
      $ref: "#components/schemas/serviceUse",
      description: "number of size tables"
    },
    advisor: {
      $ref: "#components/schemas/serviceUse",
      description: "using of SizeID Advisor"
    },
    api: {
      $ref: "#components/schemas/serviceUse",
      description: "using of SizeId Business API"
    }
  }
};
